import { getFormattedDateTime } from 'ecs-react-components/dist/index.es';

export const generateListItems = (testResults, language) => {
  let listItems = testResults.filter((value) => !value.isFiltered);
  listItems = listItems.map((testResult) => {
    const dateParts = getFormattedDateTime(testResult.startDate, testResult.startDate, language);
    const startDate = dateParts.datePart;
    let heading = '';
    testResult.labResultGroups.forEach((group, index, groups) => {
      heading += group.groupDisplayName;
      heading += (index === groups.length - 1) ? '' : ', ';
    });
    return {
      heading,
      displayBadge: !testResult.isReviewedByPatient,
      key: testResult.labResultId,
      itemId: testResult.labResultId,
      subText: testResult.requestingPhysician ?
        testResult.requestingPhysician + ', ' + startDate : startDate,
    };
  });
  return listItems;
};
